import { render, staticRenderFns } from "./clazz-card-list-add.vue?vue&type=template&id=01e52e91&scoped=true&"
import script from "./clazz-card-list-add.vue?vue&type=script&lang=js&"
export * from "./clazz-card-list-add.vue?vue&type=script&lang=js&"
import style0 from "./clazz-card-list-add.vue?vue&type=style&index=0&id=01e52e91&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e52e91",
  null
  
)

export default component.exports